import { useState } from "react";
import '../App.css';
import './SlideComponent.css';

const SlideComponent = () => {
  const [activeSlide, setActiveSlide] = useState(0);
 
   const slides = [
        <span>&nbsp;&nbsp;At <strong>Sam's Tree Service</strong>, our mission is to provide 
        expert tree care with a high degree of safety, professionalism and customer 
        satisfaction in everything we do. Led by certified arborist <strong>Sam Giauque</strong>, our skilled 
        team is trained to handle everything from hazardous tree removals to routine maintenance. 
        Whether it's a towering oak near power lines or an overgrown tree threatening a home's 
        foundation, we approach every job with precision and care. Beyond dangerous tree removals, 
        we also help homeowners and businesses enhance their properties by removing unwanted trees, 
        ensuring a safer and more beautiful landscape.
        </span>, 
        <span>&nbsp;&nbsp;<strong>Sam's Tree Service</strong> has built a strong reputation 
        across Sarasota and the surrounding area of Southwest Florida through expert 
        leadership, skilled craftsmanship, and a dedication to quality. Our commitment to 
        customer satisfaction drives everything we do, ensuring reliable, professional tree 
        care that homeowners and businesses can trust.
        </span>,
        <span>&nbsp;&nbsp;At <strong>Sam's Tree Service</strong>, we believe in precision, 
        safety, and reliability. Every tree we remove is handled with care, ensuring the 
        protection of both property and people. Our dedication to excellence has earned the 
        trust of homeowners and businesses alike, making us a go-to choice for professional 
        tree care.
        </span>
        ];
                                

  const buttonLabels = ["OUR MISSION", "WHAT SETS US APART", "OUR ETHOS"];               

  return (
    <div className="slider-container">
      {/* Buttons */}
      <div className="slider-buttons">
        {buttonLabels.map((label, index) => (
          <div
            key={index}
            onClick={() => setActiveSlide(index)}
            className={`custom-button ${activeSlide === index ? "active" : ""}`}
          >
            {label}
            {activeSlide === index && <span className="arrow">&#9660;</span>} 
          </div>
        ))}
      </div>

      {/* Slides */}
      <div className="slides">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`slide ${activeSlide === index ? "visible" : "hidden"}`}
          >
            {slide}
          </div>
        ))}
      </div>
    </div>
  );
}

export default SlideComponent;